import HeroSection from './components/HeroSection';
import FeaturedSection from './components/FeaturedSection';
import CategoryNav from './components/CategoryNav';
import LatestUpdates from './components/LatestUpdates';
import PopularRanking from './components/PopularRanking';
import FAQSection from './components/FAQSection';
import { useSchemaOrg } from '@/hooks/useSchemaOrg';
import { faqList } from '@/mocks/manhwa';

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '韩漫网站',
  url: 'https://www.example.com',
  description: '专注聚合好看的韩国漫画，提供韩漫在线免费阅读和下拉式韩漫浏览体验。',
  contactPoint: {
    '@type': 'ContactPoint',
    email: 'contact@example.com',
    contactType: 'customer service',
  },
};

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '韩漫网站',
  url: 'https://www.example.com',
  description: '好看的韩国漫画在线免费阅读平台，提供下拉式韩漫浏览体验。',
  inLanguage: 'zh-CN',
};

const faqPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqList.map((faq) => ({
    '@type': 'Question',
    name: faq.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: faq.answer,
    },
  })),
};

const webPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '好看的韩国漫画_韩漫在线免费阅读_下拉式韩漫 - 韩漫网站',
  url: 'https://www.example.com/',
  description: '韩漫网站专注聚合好看的韩国漫画，提供韩漫在线免费阅读和下拉式韩漫浏览体验。',
  inLanguage: 'zh-CN',
  isPartOf: {
    '@type': 'WebSite',
    name: '韩漫网站',
    url: 'https://www.example.com',
  },
};

export default function Home() {
  useSchemaOrg(organizationSchema);
  useSchemaOrg(websiteSchema);
  useSchemaOrg(webPageSchema);
  useSchemaOrg(faqPageSchema);
  return (
    <>
      <HeroSection />
      <FeaturedSection />
      <CategoryNav />
      <LatestUpdates />
      <PopularRanking />
      <FAQSection />
    </>
  );
}